"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterFormControl = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const StyledGrid = (0, styled_components_1.default)(core_1.Grid) `
  display: flex;
  flex-direction: column;
  .select-field {
    margin-right: 22px;
  }
  .MuiInputBase-multiline {
    align-items: flex-end;
  }
  .multiline {
    margin-bottom: 10px;
  }
`;
const FilterFormControl = props => {
    const { label, children } = props, gridProps = __rest(props, ["label", "children"]);
    return (react_1.default.createElement(StyledGrid, Object.assign({ item: true, xs: 12 }, gridProps),
        typeof label !== 'string' ? (label) : (react_1.default.createElement(core_1.Typography, { variant: 'h5', gutterBottom: true }, label)),
        children));
};
exports.FilterFormControl = FilterFormControl;
exports.default = exports.FilterFormControl;
//# sourceMappingURL=FilterFormControl.js.map